import { DatePicker as AntDatePicker, DatePickerProps as AntdDatePickerProps } from 'antd'
import styled from 'styled-components'

const StyledDatePicker = styled(AntDatePicker)<AntdDatePickerProps>`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderPrimary};

  .ant-picker-input {
    padding: 2px 0;
    input {
      &::placeholder {
        font-size: 16px;
      }
    }
  }

  &.ant-picker-large {
    .ant-picker-input > input {
      font-size: 16px;
    }
  }

  &.ant-picker-large {
    height: 40px;
  }
`

export type DatePickerProps = AntdDatePickerProps & {
  timeOfDay?: 'startOfDay' | 'endOfDay'
}

export const DatePicker: React.FC<DatePickerProps> = p => {
  const { timeOfDay, ...rest } = p

  const onChange: DatePickerProps['onChange'] = date => {
    const dateTime = timeOfDay && timeOfDay === 'endOfDay' ? date?.endOf('day') : date?.startOf('day')
    p.onChange && p.onChange(dateTime || null, dateTime?.format('DD/MM/YYYY') || '')
  }

  return (
    <StyledDatePicker
      format="DD/MM/YYYY"
      size="large"
      {...rest}
      onChange={onChange}
      value={p.value}
      getPopupContainer={(pickerNode: HTMLElement) => findNearestFixedParent(pickerNode) ?? document.body}
    />
  )
}

function findNearestFixedParent(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement

  while (parent) {
    const computedStyle = window.getComputedStyle(parent)
    if (computedStyle.getPropertyValue('position') === 'fixed') {
      return parent
    }
    parent = parent.parentElement
  }

  return null
}
